import { useState } from "react";
import useHttp from "./useHttp";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const useAction = () => {
  const navigate = useNavigate();
  const { HttpService } = useHttp();
  const [cancelLoadings, setCancelLoadings] = useState({
    getReasons: false,
    getQuestions: false,
    sendAnswers: false,
  });
  const [actionLoading, setActionLoading] = useState(false);
  const [cancelReasons, setCancelReasons] = useState(null);
  const [cancelQuestions, setCancelQuestions] = useState(null);

  const orderObj = useSelector((state) => state.TechAppReducer.orderObj);
  const profileData = useSelector((state) => state.TechAppReducer.profileData);

  const getCancelReasons = async () => {
    try {
      setCancelLoadings({ ...cancelLoadings, getReasons: true });
      const response = await HttpService.get(
        "/api/v1.1/form-generator/reasons/cancel"
      );
      setCancelLoadings({ ...cancelLoadings, getReasons: false });
      setCancelReasons(response.data.data);
    } catch ({ err, response }) {
      setCancelLoadings({ ...cancelLoadings, getReasons: false });
    }
  };

  const getCancelQuestions = async (reason_id) => {
    let array = [];
    try {
      setCancelLoadings({ ...cancelLoadings, getQuestions: true });
      const response = await HttpService.get(
        `/api/v1.1/form-generator/reasons/cancel/${reason_id}/questions?responder_type=technician&order_id=${orderObj?.id}&user_id=${profileData?.id}`
      );
      setCancelLoadings({ ...cancelLoadings, getQuestions: false });
      if (response.status === 200) {
        if (response.data.last_sent === 1) {
          toast.error(response.data.message);
        } else {
          response.data.data.questions.forEach((qu) => {
            let newObj = { id: qu.id, question: qu, answer: null };
            if (qu.validation.includes("required")) {
              newObj.required = true;
              newObj.isValid = false;
            } else {
              newObj.required = false;
              newObj.isValid = true;
            }
            array.push(newObj);
          });
          setCancelQuestions(array);
        }
      }
    } catch ({ err, response }) {
      setCancelLoadings({ ...cancelLoadings, getQuestions: false });
    }
  };

  const sendCancelAnswers = async (answersData, cancelPostData) => {
    let postData = {
      ...cancelPostData,
      ...answersData,
      responder_type: "technician",
      order_id: orderObj?.id,
      user_id: profileData?.id,
    };
    try {
      setActionLoading(true);
      const response = await HttpService.post(
        "/api/v1.0/order/action",
        postData
      );
      setActionLoading(false);
      if (response.status === 200) {
        toast.success(response?.data?.responseJSON?.message);
        navigate("/techapp");
      }
    } catch ({ err, response }) {
      setActionLoading(false);
    }
  };

  const exports = {
    getCancelReasons,
    getCancelQuestions,
    sendCancelAnswers,
    cancelReasons,
    cancelQuestions,
    setCancelQuestions,
    cancelLoadings,
    actionLoading,
  };
  return exports;
};
export default useAction;
